var r,t;function n(){if(t)return r;t=1;var n=Math.ceil,a=Math.floor;return r=Math.trunc||function(r){var t=+r;return(t>0?a:n)(t)}}export{n as __require};
//# sourceMappingURL=math-trunc.js.map
